import React, { useEffect, useState } from 'react';

import './list-local-filter.styles.scss';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { setFilterInput, setLocalFilterFieldNamesAndValues } from "../../redux/filter/filter.actions";
import { selectFilterInput, selectLocalFilterFieldNamesAndValues } from "../../redux/filter/filter.reselect";
import { useDebounce } from "use-debounce"
import { useMediaQuery } from 'react-responsive';

import LocalFilterField from '../local-filter-filed/local-filter-field.component';
import { isObjectsEqual } from '../../utils/object-values.util';
import IconDownArrow from '../../assets/icons/down-arrow.svg';

const ListLocalFilter = ({
    localFilterFields,
    setLocalFilterFieldNamesAndValues,
    localFilter,
    setFilterInput,
    filterInput
}) => {
    const [mount, setMount] = useState(false)
    const [inputNameAndValue, setInputNameAndValue] = useState({});
    const [value] = useDebounce(inputNameAndValue, 1000);
    const isMobileView = useMediaQuery({ maxWidth: 991 });
    // Collapsed by default so the filter bar doesn't eat mobile screen space
    // before the user asks for it; ignored on desktop, where it's always shown.
    const [isCollapsed, setIsCollapsed] = useState(true);

    useEffect(() => {
        if (Object.keys(localFilter).length !== 0) {
            setInputNameAndValue(localFilter)
        }
        setMount(true)
    }, [])

    useEffect(() => {
        if (mount &&
            !isObjectsEqual(inputNameAndValue, localFilter)
        ) {
            setLocalFilterFieldNamesAndValues(inputNameAndValue);
        }
    }, [value])

    useEffect(() => {
        if (mount &&
            Object.keys(inputNameAndValue).length !== 0 &&
            filterInput !== ''
        ) {
            setFilterInput('')
        }
    }, [value])

    useEffect(() => {
        setInputNameAndValue(localFilter)
    }, [localFilter])

    const showFields = !isMobileView || !isCollapsed;

    return (
        <div className="list-table-local-filter">
            <div className="list-table-local-filter__title">
                Filter by
                {isMobileView &&
                    <button
                        type="button"
                        className="list-table-local-filter__title__toggle"
                        onClick={() => setIsCollapsed(prevState => !prevState)}
                        aria-label={isCollapsed ? "Show filters" : "Hide filters"}
                        aria-expanded={!isCollapsed}
                    >
                        <img
                            className={`list-table-local-filter__title__toggle__icon ${isCollapsed ? '' : 'list-table-local-filter__title__toggle__icon--up'}`}
                            src={IconDownArrow}
                            alt=""
                        />
                    </button>
                }
            </div>
            {showFields &&
                <div className="list-table-local-filter__fields">
                    {
                        localFilterFields.map((localFilterField, index) => (
                            <LocalFilterField key={index}
                                {...localFilterField}
                                handleChange={event => setInputNameAndValue({ [event.target.name]: event.target.value })}
                                value={inputNameAndValue ?
                                    Object.keys(inputNameAndValue).length ?
                                        inputNameAndValue[localFilterField.name] :
                                        '' :
                                    ''}
                            />
                        ))
                    }
                </div>
            }
        </div>
    )
};

const mapStateToProps = createStructuredSelector({
    localFilter: selectLocalFilterFieldNamesAndValues,
    filterInput: selectFilterInput,
});

const mapDispatchToProps = (dispatch) => ({
    setLocalFilterFieldNamesAndValues: (inputNameAndValue) => dispatch(setLocalFilterFieldNamesAndValues(inputNameAndValue)),
    setFilterInput: (filterInput) => dispatch(setFilterInput(filterInput))
})

export default connect(mapStateToProps, mapDispatchToProps)(ListLocalFilter);
